import { render, staticRenderFns } from "./CsAvatar.vue?vue&type=template&id=282d3044&scoped=true&"
import script from "./CsAvatar.vue?vue&type=script&setup=true&lang=js&"
export * from "./CsAvatar.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./CsAvatar.vue?vue&type=style&index=0&id=282d3044&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282d3044",
  null
  
)

export default component.exports